import {AssetsRequestType} from "../../../newShared/GQLTypes";

export const assetRequestTypeTitleMapper: Record<AssetsRequestType, string> = {
    ADD_ASSET: 'Add asset',
    REMOVE: 'Remove asset',
    REQUEST: 'Request asset'
}
